import Web3 from "web3";
import { supportNetwork  } from './network';


export const infura_Id = "84842078b09946638c03157f83405213";

export const getRpcUrl = (chainId) => {
  return supportNetwork[chainId] ? supportNetwork[chainId].rpc : supportNetwork['default'].rpc;
}


export const getWeb3 = (chainId) =>{
  return new Web3(getRpcUrl(chainId));
}



export const supportChainId = Object.keys(supportNetwork).map(function (key) {
    return parseInt(key);
});

